import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { TickerTrade } from '../types';
import { useMarketContext } from '../contexts/MarketContext';
import { fetchRecentTrades } from '../services/api';
import { truncateAddress } from '../utils/utils';

const Ticker: React.FC = () => {
  const { loading: marketsLoading } = useMarketContext();
  const [tickerData, setTickerData] = useState<TickerTrade[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadTrades = async () => {
      try {
        const trades = await fetchRecentTrades();
        setTickerData(trades);
      } catch (error) {
        console.error('Error fetching trades:', error);
      } finally {
        setLoading(false);
      }
    };

    if (!marketsLoading) {
      loadTrades();
      // Refresh ticker data every minute
      const interval = setInterval(loadTrades, 60000);
      return () => clearInterval(interval);
    }
  }, [marketsLoading]);

  const getRandomEmoji = () => {
    const emojis = ['🦊', '🦁', '🐲', '🚀', '🌟', '💰', '🎉', '🐼', '🦋', '🌮', '🍔', '🍕', '🏖️', '❤️‍', '🥳', '👻', '👽', '👾', '💡'];
    return emojis[Math.floor(Math.random() * emojis.length)];
  };

  const renderTickerItems = () => {
    return tickerData.map((item) => {
      return (
        <Link to={`/token/${item.ContractAddress}`} className="ticker-link" key={item.TradeId}>
          <span className="ticker-item">
            <span className="icon">{getRandomEmoji()}</span>
            <span className="address">{truncateAddress(item.WalletAddress)}</span>
            <span className={`action ${item.BuySell.toLowerCase()}`}>{item.BuySell}</span>
            <span className="amount">{item.TokenQty}</span>
            <span className="of">of</span>
            <span className="token-icon">
              <img
                src={`../game-images/${item.LogoUrl}`}
                alt={item.Symbol}
              />
            </span>
            <span className="token-name">${item.Symbol}</span>
          </span>
        </Link>
      );
    });
  };

  if (loading || marketsLoading || tickerData.length === 0) {
    return <div className="ticker-wrapper">Loading...</div>;
  }

  return (
    <div className="ticker-wrapper">
      <div className="ticker-container">
        <div className="ticker">
          {renderTickerItems()}
          {renderTickerItems()}
        </div>
      </div>
    </div>
  );
};

export default Ticker;